import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

const AudienceFitV2 = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/50">
      <div className="container px-4 md:px-6 mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Este trabalho faz sentido quando a decisão merece planejamento.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Para quem é */}
          <div className="rounded-xl border bg-card text-card-foreground shadow p-8">
            <h3 className="text-xl font-semibold mb-6 flex items-center gap-2">
              <CheckCircle2 className="w-6 h-6 text-green-500" />
              Para quem é:
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Tem um objetivo patrimonial definido ou quer estruturá-lo.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Aceita comparar prazo, liquidez, custos e riscos antes de escolher.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Pode avaliar uma estratégia de longo prazo sem depender de uma data garantida de contemplação.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Quer entender a diferença entre consórcio, crédito, imóvel e outras alternativas aplicáveis ao seu caso.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Prefere uma recomendação explicada, documentada e compatível com seu contexto.</span>
              </li>
            </ul>
          </div>

          {/* Para quem não é */}
          <div className="rounded-xl border bg-card text-card-foreground shadow p-8">
            <h3 className="text-xl font-semibold mb-6 flex items-center gap-2">
              <XCircle className="w-6 h-6 text-red-500" />
              Para quem não é:
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Precisa de dinheiro imediatamente e não pode esperar as regras da modalidade escolhida.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Procura retorno rápido, especulação ou garantia de rentabilidade.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Quer uma data garantida de contemplação.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Não pretende analisar custos contratuais, reajustes, liquidez e riscos do ativo.</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 shrink-0" />
                <span className="text-muted-foreground">Está buscando apenas uma cotação, sem interesse em entender a decisão completa.</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg font-medium text-foreground">
            Se o seu caso não se encaixar, tudo bem. A melhor decisão pode ser não contratar agora.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AudienceFitV2;
